import { createContext, useContext } from 'react';

/**
 * Qué armazón está montado. Las páginas que se usan en los dos sitios (el puesto y el
 * escritorio) consultan esto para decidir si ocupan todo el ancho o se quedan en columna.
 */
export interface ShellContextValue {
  variant: 'desktop' | 'station';
}

export const ShellContext = createContext<ShellContextValue>({ variant: 'desktop' });

export function useShellVariant(): 'desktop' | 'station' {
  return useContext(ShellContext).variant;
}
